import SBox from 'components/opinionless/SBox'
import React from 'react'
import { BoxProps } from 'rebass'
import { useMemo } from 'react'

export interface SIconProps extends BoxProps {
    icon: any
    tintColor?: string

    // EITHER
    size?: number | number[]
    // OR
    width?: number[] | string
    height?: number[] | string
}

const SIcon = (props: SIconProps) => {
    const { icon: IconComponent, tintColor = 'white', sx = {}, size, width, height, ...otherProps } = props

    const resolvedTintColor = tintColor

    const resolvedSizeProps = useMemo(() => {
        if (size) {
            return { width: size, height: size }
        } else {
            return { width, height }
        }
    }, [size, width, height])

    return <SBox sx={sx} as={IconComponent} {...{ color: resolvedTintColor }} {...resolvedSizeProps} {...otherProps} />
}

export default SIcon
